module.exports = __webpack_public_path__ + "static/media/orderdaymaster.d8534fc0.xlsx";